export default function CCtypeH() {
  return <h2>C Ctype H</h2>;
}
